import React from 'react';
import classNames from 'classnames';
import {
  arrayOf, node, oneOf, oneOfType, string
} from 'prop-types';

export const SampleFooter = ({ channel, children, className }) => {
  const sampleFooterClasses = classNames(className, 'sample__footer', {
    'sample__footer--mobile': channel === 'mobile'
  });
  return (
    <div className={sampleFooterClasses}>
      {children}
    </div>
  );
};

SampleFooter.displayName = 'SampleFooter';

SampleFooter.propTypes = {
  channel: oneOf(['desktop', 'mobile', 'tablet']),
  children: oneOfType([node, arrayOf(node)]),
  className: string
};

SampleFooter.defaultProps = {
  channel: 'desktop',
  children: null,
  className: null
};
